var map = {
	"./calendar.webp": 1521,
	"./cash.webp": 1522,
	"./check-in-title-bg.webp": 1523,
	"./coin.webp": 1524,
	"./current-check-in-container.webp": 1525,
	"./current-last-day-check-in-container.webp": 1526,
	"./daily-check-in-bg.webp": 1527,
	"./default-check-in-container.webp": 1528,
	"./giftbox.webp": 1529,
	"./golden-coin.webp": 1530,
	"./halfweek-check-in-container.webp": 1531,
	"./last-day-check-in-container.webp": 1532,
	"./missed-checkIn.webp": 1533,
	"./more-cash.webp": 1534,
	"./more-coin.webp": 1535,
	"./more-spin.webp": 1536,
	"./need-deposit.webp": 1537,
	"./present.webp": 1538,
	"./reward-coin.webp": 1539,
	"./shine.webp": 1540,
	"./silver-coin.webp": 1541,
	"./spin.webp": 1542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;